import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { BillingTierResponse } from '../../../types/BillingTier';

export type UseGetAllBillingTiersProps = {
  enabled?: boolean;
};

export const fetchAllBillingTiers = async () => {
  const response = await CustomAxios.get<BillingTierResponse>(`user_roles/tiers`);
  const { data } = response;
  return data;
};

export function useGetAllBillingTiers({ enabled = true }: UseGetAllBillingTiersProps) {
  const queryKey: any = [queryKeys.allBillingTiers];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllBillingTiers(),
    placeholderData: keepPreviousData,
  });
  return query;
}
